<template>
  <div class="uploader" :style='minimalMode?"height: 100%;outline: 0;":""'>
    <img v-if='!minimalMode' :src="imageUrl" class="uploader__preview">
    <b-button class='w-100' variant="outline-primary" v-else>Add Image <b-spinner v-if='uploading'></b-spinner></b-button>
    <input
      type="file"
      class="uploader__input"
      accept="image/*"
      @change="fileChanged"
    >
  </div>
</template>

<script>
export default {
  props: {
    'uploaded': Object,
    'src': String,
    'minimalMode':{
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      imageUrl: this.src,
      uploading: false
    }
  },

  methods: {
    // TODO: dry this out with the background uploader
    fileChanged(e) {
      let files = e.target.files

      if (files.length > 0) {
        // only upload the first file
        let file = files[0]
        this.uploading = true
        fetch(`${process.env.VUE_APP_UPLOADER_API_URL}?filename=${file.name}&filetype=${file.type}`)
          .then((res) => res.json())
          .then((json) => {
            return Promise.all([fetch(json.signedRequest, {
              method: 'PUT',
              body: file
            }), json.url])
          })
          .then(([res, url]) => {
            this.imageUrl = url
            this.$emit('uploaded', url)
            return res
          })
          .catch(err => console.error(err))
        this.uploading = false
      }
    }
  }
}
</script>

<style scoped>
  .uploader {
    position: relative;
    height: 200px;

    background: #EEE;
    outline: dashed 2px rgba(0,0,0,0.2);
    outline-offset: -10px;
    text-align: center;
  }

  .uploader:hover {
    background: lightblue;
  }

  .uploader__input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    opacity: 0;
    cursor: pointer;
  }

  .uploader__preview {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
</style>
